document.addEventListener('DOMContentLoaded', () => {
	const waves = document.querySelectorAll('.frame-wave-white, .gallery-slider');
	if (!waves.length || !('IntersectionObserver' in window)) return;

	const observer = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			entry.target.classList.toggle('is-inview', entry.isIntersecting);
		});
	});

	waves.forEach((wave) => observer.observe(wave));
});
